import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Section, CTAButton, GradientText } from './UI';
import { Gift, ShieldCheck, Clock, Download, PenTool, Rocket, DollarSign, CheckCircle2, AlertTriangle, Bot } from 'lucide-react';
export function OfferSection() {
  return <div className="bg-black text-white" data-id="element-229">
      {/* What happens after purchase */}
      <Section className="py-24 bg-white/[0.02] border-t border-white/10" data-id="element-230">
        <div className="text-center mb-16" data-id="element-231">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-232">
            ¿Qué pasa después de comprar?
          </h2>
          <p className="text-xl text-gray-400" data-id="element-233">
            Un proceso claro y sin fricciones hacia tu primer activo.
          </p>
        </div>

        <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6" data-id="element-234">
          {[{
          icon: Clock,
          title: 'Paso 1',
          desc: 'Recibes acceso inmediato'
        }, {
          icon: Download,
          title: 'Paso 2',
          desc: 'Descargas libro y bonos'
        }, {
          icon: Bot,
          title: 'Paso 3',
          desc: 'Usas los prompts'
        }, {
          icon: PenTool,
          title: 'Paso 4',
          desc: 'Creas tu producto'
        }, {
          icon: Rocket,
          title: 'Paso 5',
          desc: 'Lo publicas'
        }, {
          icon: DollarSign,
          title: 'Paso 6',
          desc: 'Empiezas a vender'
        }].map((step, i) => <div key={i} className="bg-[#0a0a0a] border border-white/10 rounded-2xl p-6 text-center flex flex-col items-center relative group hover:border-yellow-500/30 transition-colors" data-id="element-235">
              <div className="w-12 h-12 bg-white/5 rounded-full flex items-center justify-center mb-4 group-hover:bg-yellow-500/10 group-hover:text-yellow-400 transition-colors" data-id="element-236">
                <step.icon className="w-6 h-6" data-id="element-237" />
              </div>
              <div className="text-yellow-500 font-bold text-xs uppercase tracking-wider mb-2" data-id="element-238">
                {step.title}
              </div>
              <p className="text-sm text-gray-300 font-medium" data-id="element-239">{step.desc}</p>
              {i < 5 && <div className="hidden lg:block absolute top-1/2 -right-4 w-4 h-0.5 bg-white/10" data-id="element-240" />}
            </div>)}
        </div>
      </Section>

      {/* Offer Stack */}
      <Section id="oferta" className="border-t border-white/10 relative py-24" data-id="element-241">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-yellow-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-242" />

        <div className="text-center mb-16 relative z-10" data-id="element-243">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-500/10 border border-red-500/20 text-sm font-bold text-red-400 mb-6" data-id="element-244">
            <AlertTriangle className="w-4 h-4" data-id="element-245" /> OFERTA DE LANZAMIENTO
          </div>
          <h2 className="text-4xl md:text-6xl font-extrabold mb-6" data-id="element-246">
            Todo lo que obtienes hoy
          </h2>
          <p className="text-xl md:text-2xl text-gray-400" data-id="element-247">
            Una oferta diseñada para que recuperar tu inversión sea inevitable.
          </p>
        </div>

        <div className="max-w-4xl mx-auto bg-[#0a0a0a] border border-white/10 rounded-3xl overflow-hidden relative z-10 shadow-2xl" data-id="element-248">
          {/* Core Product */}
          <div className="p-8 md:p-12 border-b border-white/10 flex flex-col md:flex-row gap-8 items-center bg-gradient-to-br from-white/[0.02] to-transparent" data-id="element-249">
            <div className="w-full md:w-1/3 shrink-0 relative" data-id="element-250">
              <div className="absolute inset-0 bg-blue-500/20 blur-[40px] rounded-full" data-id="element-251" />
              <img src="https://cdn.magicpatterns.com/uploads/d27q3JeVdd13pGBbntuQ6W/portada_(tu_primer_activo_digital).png" alt="Tu Primer Activo Digital" loading="lazy" decoding="async" className="w-full drop-shadow-2xl relative z-10" data-id="element-252" />
            </div>
            <div data-id="element-253">
              <div className="inline-block bg-yellow-400/10 text-yellow-400 font-bold text-xs tracking-widest uppercase px-3 py-1 rounded-full mb-4" data-id="element-254">
                PRODUCTO PRINCIPAL
              </div>
              <h3 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-255">
                Tu Primer Activo Digital™
              </h3>
              <p className="text-gray-400 text-lg mb-6 leading-relaxed" data-id="element-256">
                La guía maestra paso a paso para idear, crear y vender tu
                producto digital usando Inteligencia Artificial en tiempo
                récord.
              </p>
              <div className="inline-block bg-white/5 px-4 py-2 rounded-lg text-gray-400 line-through font-medium" data-id="element-257">
                Valor real: $97
              </div>
            </div>
          </div>

          {/* Bonuses */}
          <div className="p-8 md:p-12 bg-black/50" data-id="element-258">
            <h4 className="text-2xl font-bold mb-8 flex items-center gap-3" data-id="element-259">
              <Gift className="text-yellow-400 w-8 h-8" data-id="element-260" /> + 3 Bonos de Acción
              Rápida
            </h4>

            <div className="space-y-6" data-id="element-261">
              {[{
              img: 'https://cdn.magicpatterns.com/uploads/1REYp1XjgTYR1Gn6SzPHu8/bono_1.png',
              title: 'Bono 1: 500 Prompts Premium',
              desc: 'Instrucciones exactas de copiar y pegar para que la IA investigue, cree y escriba por ti.',
              value: '$47'
            }, {
              img: 'https://cdn.magicpatterns.com/uploads/mvo5ohXqjEEHAYiKLHin8u/bono_2.png',
              title: 'Bono 2: 50 Nichos Rentables',
              desc: 'Nichos validados para 2026 con alta demanda y compradores activos. Cero suposiciones.',
              value: '$37'
            }, {
              img: 'https://cdn.magicpatterns.com/uploads/2mcY1V47emJykrePiEj7Wm/bono_3.png',
              title: 'Bono 3: 200 Hooks Virales',
              desc: 'Plantillas de ganchos para detener el scroll en Reels, TikTok y Anuncios para vender tu activo.',
              value: '$27'
            }].map((bonus, i) => <div key={i} className="flex flex-col sm:flex-row gap-6 items-center bg-white/5 border border-white/5 rounded-2xl p-6 hover:bg-white/10 transition-colors" data-id="element-262">
                  <img src={bonus.img} alt={bonus.title} loading="lazy" decoding="async" className="w-32 object-contain drop-shadow-lg shrink-0" data-id="element-263" />
                  <div className="flex-1 text-center sm:text-left" data-id="element-264">
                    <h5 className="font-bold text-xl text-white mb-2" data-id="element-265">
                      {bonus.title}
                    </h5>
                    <p className="text-gray-400 text-sm mb-4 leading-relaxed" data-id="element-266">
                      {bonus.desc}
                    </p>
                    <div className="inline-block bg-white/5 px-3 py-1 rounded text-gray-500 text-sm line-through font-medium" data-id="element-267">
                      Valor: {bonus.value}
                    </div>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Total Value & Price */}
          <div className="p-8 md:p-16 bg-gradient-to-b from-white/5 to-white/10 text-center relative overflow-hidden" data-id="element-268">
            <div className="flex flex-col items-center justify-center mb-10 relative z-10" data-id="element-269">
              <span className="text-gray-400 text-xl mb-2 font-medium" data-id="element-270">
                Valor Total Real:
              </span>
              <span className="text-gray-500 line-through text-3xl font-bold mb-8" data-id="element-271">
                $208
              </span>

              <span className="text-white font-bold text-2xl mb-2 uppercase tracking-widest" data-id="element-272">
                Hoy:
              </span>
              <div className="text-7xl md:text-8xl font-extrabold text-transparent bg-clip-text bg-gradient-to-b from-yellow-300 to-yellow-600 drop-shadow-lg mb-4" data-id="element-273">
                $17.99
              </div>
              <span className="text-yellow-400/80 font-bold text-lg uppercase tracking-widest" data-id="element-274">
                Pago Único
              </span>
            </div>

            <div className="relative z-10" data-id="element-275">
              <CTAButton text="OBTENER TODO POR $17.99" variant="primary" className="w-full max-w-xl mx-auto text-xl md:text-2xl py-6" data-id="element-276" />
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 text-sm font-bold text-red-400 relative z-10" data-id="element-277">
              <div className="flex items-center gap-2 bg-red-500/10 px-4 py-2 rounded-full" data-id="element-278">
                <Clock className="w-4 h-4 animate-pulse" data-id="element-279" /> El precio aumentará
                próximamente
              </div>
            </div>
          </div>
        </div>
      </Section>

      {/* Guarantee */}
      <Section className="py-12" data-id="element-280">
        <div className="max-w-4xl mx-auto bg-gradient-to-br from-green-900/20 to-black border border-green-500/30 rounded-3xl p-8 md:p-16 text-center flex flex-col items-center relative overflow-hidden shadow-[0_0_50px_rgba(34,197,94,0.1)]" data-id="element-281">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gradient-to-r from-transparent via-green-500 to-transparent" data-id="element-282"></div>

          <div className="w-24 h-24 bg-green-500/20 rounded-full flex items-center justify-center mb-8 border border-green-500/40 shadow-[0_0_30px_rgba(34,197,94,0.3)]" data-id="element-283">
            <ShieldCheck className="w-12 h-12 text-green-400" data-id="element-284" />
          </div>
          <h3 className="text-3xl md:text-4xl font-extrabold mb-6 text-white" data-id="element-285">
            🛡 Garantía Blindada de 7 Días
          </h3>
          <p className="text-green-400 font-bold text-xl mb-6 uppercase tracking-wide" data-id="element-286">
            El riesgo es completamente nuestro.
          </p>
          <p className="text-gray-300 text-lg md:text-xl leading-relaxed max-w-2xl" data-id="element-287">
            Descarga el material. Revisa el Sistema C.R.E.A.™ Aplica los
            prompts. Si sientes que este no es el mejor recurso que has
            adquirido para crear tu producto digital, envíanos un correo y te
            devolveremos el 100% de tu dinero. Sin preguntas.
          </p>
        </div>
      </Section>
    </div>;
}